export default "__VITE_ASSET__7c7d113d__"